import type { ComparisonSection } from "../experiment/types.js";
import { renderRefusal } from "./refusal.js";

/** Une confrontation est fournie par son domaine ; son refus reste obligatoire. */
export function renderComparisonSection(section: ComparisonSection): string {
  return section.kind === "unavailable" ? renderRefusal(section.reasons) : section.chart + section.table;
}
